const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const oneDecimal = new Intl.NumberFormat('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

/** Parses API numbers, which arrive as numbers or decimal strings like "72.00". */
export const toNumber = (value: unknown): number => {
  const n = typeof value === 'number' ? value : parseFloat(String(value ?? ''));
  return Number.isFinite(n) ? n : 0;
};

/** $1,234.50 (negative values use a real minus sign) */
export const formatMoney = (value: unknown): string => {
  const n = toNumber(value);
  return n < 0 ? `−${currency.format(Math.abs(n))}` : currency.format(n);
};

/** 38.5 → "38.5", 40 → "40.0" */
export const formatHours = (value: unknown): string => oneDecimal.format(toNumber(value));

/** The server keeps times in UTC but sends them with no zone, which a browser would read as local time. */
export const serverTime = (value: string): Date =>
  new Date(/(Z|[+-]\d\d:\d\d)$/i.test(value) ? value : `${value}Z`);

/** $12,000 → "$12k" for chart axes */
export const formatMoneyShort = (value: number): string => {
  if (value === 0) return '$0';
  const sign = value < 0 ? '−' : '';
  const abs = Math.abs(value);
  return abs >= 1000 ? `${sign}$${Number((abs / 1000).toFixed(1))}k` : `${sign}$${abs.toFixed(0)}`;
};
